import { useCallback } from 'react';

import { useConfig } from 'config';
import { usePopups } from 'store';

const useCookiePopup = () => {
  const { addPopup, removePopup } = usePopups();
  const isCookieEnabled = useConfig('config.siteConfig.cookieModal.enabled');

  const closeCookiePopup = useCallback(() => {
    window.localStorage.setItem('userConsentStatus', 'understood');
    removePopup('non-blocking');
  }, [removePopup]);

  const showCookiePopup = useCallback(() => {
    const isCookieAgreed = window.localStorage.getItem('userConsentStatus');

    if (isCookieAgreed !== 'understood' && isCookieEnabled) {
      addPopup({
        type: 'non-blocking',
        contentType: 'cookie',
      });
    }
  }, [addPopup, isCookieEnabled]);

  return {
    showCookiePopup,
    closeCookiePopup,
  };
};

export default useCookiePopup;
